module.exports = __webpack_public_path__ + "static/media/ban1.e9ce17eb.jpg";